import useRScoreV2 from "./useRScoreV2";

export default function useRScore(
  branchId,
  startDate,
  endDate,
  enabled = true
) {
  const { porFilial, isLoading, isError, error } = useRScoreV2({
    branchIds: branchId ? [branchId] : [],
    startDate,
    endDate,
    enabled,
  });
  return {
    data: branchId ? porFilial[branchId] : undefined,
    isLoading,
    isError,
    error,
  };
}
